import { createAsyncThunk } from "@reduxjs/toolkit";
import { additionalKycDataApi } from "../../utils/api";

export const actionAdditionalKycData = createAsyncThunk(
  "compliance/additionalKycDataApi",
  async (accId) => {
    const response = await additionalKycDataApi(accId);
    return response;
  }
);
